import Entity from "../../../class/abstract/Entity";
import stringTools from "../../../class/tool/StringTools";

class User extends Entity {
    lastname = "";
    firstname = "";
    email = "";
    gender = "Non défini";
    phone = "";
    mobile = "";
    api_key = "";
    rules = [];
    partnership_id = null;
    partnership = null;
	bigBisoux = 0;

    constructor(datas = {}) {
        super(datas);

        this.setAttributes(datas);
    }

    setAttributes(datas) {
		let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
				let exceptKeys = [];

				if (!exceptKeys.includes(key))
					Reflect.set(this, key, datas[key]);
            }
        }
    }

    fullName() {
        return this.lastname.toLocaleUpperCase() + " " + stringTools.capitalizeFirstLetter(this.firstname);
    }
}

export default User;
